import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from '@vue/reactivity'
import WelcomePage from './components/WelcomePage.vue'
import ShowMap from './components/ShowMap.vue'

type pageType = 'welcome' | 'map';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const page = ref<pageType>('welcome')

function goToMap(value: pageType){
  page.value = value
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (page.value === 'welcome')
      ? (_openBlock(), _createBlock(WelcomePage, {
          key: 0,
          onCreateMap: _cache[0] || (_cache[0] = ($event: any) => (goToMap('map')))
        }))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (page.value ==='map')
        ? (_openBlock(), _createBlock(ShowMap, {
            key: 0,
            onExitMap: _cache[1] || (_cache[1] = ($event: any) => (goToMap('welcome')))
          }))
        : _createCommentVNode("", true)
    ], 1024))
  ], 64))
}
}

})